<template>
  <!--分库缓存清理-->
  <div>
    <el-divider content-position="left"><h3>分库缓存清理</h3></el-divider>
    <dynamicTable
      ref="dynamicTable"
      class="myTable"
      :table-header="tableData.title"
      :table-data="tableData.data"
      :loading="loading"
      @handleClick="handleClick"
    />
  </div>
</template>

<script>
import dynamicTable from "./components/Table/v-dynamicTable";
import * as cacheApi from "./api.js";
export default {
  name: "depotsCache",
  components: {
    dynamicTable,
  },
  props:{
    // 缓存登录状态
    cachedLoginState:{
      type: String,
      default:""
    }
  },
  data() {
    return {
      loading: false,
      tableData: {
        data: [
          {
            operation: "刷新",
            message: "",
            depotsFlag: "db.report",
            explain: "刷新report分库配置状态缓存",
          },
          {
            operation: "刷新",
            message: "",
            depotsFlag: "db.viewsearch",
            explain: "刷新viewsearch分库配置状态缓存",
          },
          {
            operation: "刷新",
            message: "",
            depotsFlag: "db.allsearch",
            explain: "刷新allsearch分库配置状态缓存",
          },
          {
            operation: "刷新",
            message: "",
            depotsFlag: "db.myworkbench",
            explain: "刷新myworkbench分库配置状态缓存",
          },
        ],
        title: [
          {
            index: 1,
            sortable: false,
            title: "操作",
            prop: "operation",
            type: "button",
            width:80
          },
          {
            index: 1,
            sortable: false,
            title: "",
            prop: "message",
            type: "text",
            width:150
          },
          {
            index: 2,
            sortable: false,
            title: "分库标识",
            prop: "depotsFlag",
            type: "text",
          },
          {
            index: 3,
            sortable: false,
            title: "说明",
            prop: "explain",
            type: "text",
          },
        ],
      },
    };
  },
  methods:{
    /**
     * 监听table操作事件  刷新
     */
    handleClick(scope) {
      scope.row.message = '正在刷新，请稍后...'
      let params = {
        // 分库缓存清理    db.report；或db.viewsearch；	或db.allsearch；或	db.myworkbench
        service:scope.row.depotsFlag,
        // 登录状态
        cachedLoginState:this.cachedLoginState
      }
      cacheApi.cacheHandle(params).then(res => {
        if (res.result) {
          scope.row.message = '刷新成功'
        } else {
          this.$message.info(res.returnInfo);
        }
      }).catch(error=>{
        this.$message.error(error.returnInfo);
      })
    }
  }
};
</script>

<style scoped>
</style>
